module.exports = __webpack_public_path__ + "static/media/wfl.9be36291.jpg";